<div id="move-files-dialog-container">
    <h1 mat-dialog-title>{{ 'dialog.move-files.label.title' | translate }}</h1>
    <mat-error [@openClose]="moveFileError ? 'open' : 'closed'" mat-dialog-title>
        {{moveFileError}}
    </mat-error>
    <div mat-dialog-content>
        <app-move-tree id="move-tree" [node]="data.node" [mediaTree]="data.mediaTree" [files]="data.files"
            (selectFolder)="selectFolder($event)">
        </app-move-tree>
    </div>
    <div mat-dialog-actions>
        <button color="warn" mat-button (click)="onAbortClick()"
            cdkFocusInitial>{{ 'general.button.cancel' | translate | uppercase }}</button>
        <span class="default-spacer"></span>
        <button mat-button (click)="onSelectClick()"
            [disabled]="!selectedFolder">{{ 'general.button.move' | translate | uppercase }}</button>
    </div>
</div>